import { RouteType } from '../types';
import { getSchoolTimingConfigs } from '../../../apis/transport/schoolTimingConfigs';

const DEFAULT_DEPARTURE_WINDOW_OPTIONS = [
  '06:00 am and 07:30 am',
  '06:00 am and 08:00 am',
  '06:00 am and 10:00 am',
  '06:45 am and 07:15 am',
  '07:15 am and 07:45 am',
  '07:15 am and 08:45 am',
  '07:45 am and 08:15 am',
  '07:45 am and 09:00 am',
  '08:15 am and 08:45 am',
  '08:15 am and 09:30 am',
  '08:45 am and 09:15 am',
  '09:15 am and 09:45 am',
  '09:30 am and 11:30 am',
  '10:30 am and 12:45 pm',
  '11:00 am and 11:45 am',
  '11:15 am and 12:00 pm',
  '11:30 am and 12:30 pm',
  '12:00 pm and 01:00 pm',
  '12:00 pm and 02:00 pm',
  '12:00 pm and 05:00 pm',
  '01:00 pm and 02:30 pm',
  '02:40 pm and 04:30 pm',
  '02:15 pm and 03:30 pm',
  '02:00 pm and 06:00 pm',
  '03:45 pm and 05:00 pm',
  '4:15 pm and 6:30 pm',
  '05:45 pm and 07:15 pm'
];

export const getDepartureWindowOptions = () => {
  return DEFAULT_DEPARTURE_WINDOW_OPTIONS;
};

const parseTimeToMinutes = (time: string): number => {
  const match = time.trim().match(/^(\d{1,2}):(\d{2})\s*(am|pm)$/i);
  if (!match) {
    return 0;
  }
  const [, hoursStr, minutesStr, meridiem] = match;
  let hours = parseInt(hoursStr, 10) % 12;
  if (meridiem.toLowerCase() === 'pm') {
    hours += 12;
  }
  return hours * 60 + parseInt(minutesStr, 10);
};

const getWindowStartInMinutes = (option: string): number => {
  const [from] = option.split(' and ');
  return parseTimeToMinutes(from);
};

export const getSchoolDepartureWindowOptions = async (
  school: string,
  type: RouteType
): Promise<string[]> => {
  const defaultOptions = getDepartureWindowOptions();
  if (!school) {
    return defaultOptions;
  }

  try {
    const schoolConfigs = await getSchoolTimingConfigs(school, type);
    if (schoolConfigs.length === 0) {
      return defaultOptions;
    }

    const schoolOptions = schoolConfigs.map(
      (config) => `${config.startTime} and ${config.endTime}`
    );
    const mergedOptions = Array.from(
      new Set([...defaultOptions, ...schoolOptions])
    );
    return mergedOptions.sort(
      (a, b) => getWindowStartInMinutes(a) - getWindowStartInMinutes(b)
    );
  } catch (error) {
    console.error('Failed to fetch school-specific departure windows', error);
    return defaultOptions;
  }
};
